import React from "react";
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { StaticImage } from 'gatsby-plugin-image';
import '../../sass/components/flexibleModules/_components.companyAnnouncement.scss';

const CompanyAnnouncementsComponent = ({ data }) => {
    return (
        <div className="cp-genericCompanyAnnouncement" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericCompanyAnnouncement__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                <h2>Planful In the News</h2>
                <div className="cp-genericCompanyAnnouncement__section l--flex">
                    <div className="cp-genericCompanyAnnouncement__section-announcements">
                        {data.announcements &&
                            <>
                                {data.announcements.map((announcement, index) => (
                                    <div className="l-announcements" key={index}>
                                        {announcement.date &&
                                            <span className="l-date">{announcement.date}</span>
                                        }
                                        <h3 dangerouslySetInnerHTML={{ __html: announcement.title }} />
                                        <div dangerouslySetInnerHTML={{ __html: announcement.excerpt }} />
                                        <Link to={`/pressrelease/${announcement.slug}`}><span className="l--inlineblock">Read More</span> <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" /></Link>
                                    </div>
                                ))}
                            </>
                        }
                        <Link to={`/newsroom/`} className="l-textlink"><span>View all Announcements</span> <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" /></Link>
                    </div>
                    <div className="cp-genericCompanyAnnouncement__section-news">
                        <div className="l-newsSection">
                            {data.news &&
                                <>
                                    {data.news.map((newsSection, index) => (
                                        <a className="l-newsSection__section l--flex" href={newsSection.newsPostFields.inTheNews.inTheNewsLink.url} rel="noreferrer" target="_blank" key={index}>
                                            {newsSection.featuredImage &&
                                                <GatsbyImage image={getImage(newsSection.featuredImage.node.gatsbyImage)} alt={newsSection.featuredImage.node.altText} />
                                            }
                                            <span className="l-newsSection__section-right">
                                                <span className="l--newsHeader">{newsSection.title}</span>
                                                <span className="l--newsExcerpt" dangerouslySetInnerHTML={{ __html: newsSection.excerpt }} />
                                            </span>
                                        </a>
                                    ))}
                                </>
                            }
                        </div>
                        <Link to={`/newsroom/`} className="l-textlink"><span>View all News</span> <StaticImage src="../../images/arrow-right-blue-textlink.svg" alt="" /></Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyAnnouncementsComponent;